import { reportAction } from './report.slice';
import { notification } from 'antd';
// import Highcharts from 'highcharts';
import {
  getCrossTabQuestions,
  getExcelDownloadData,
  getSurveyChartData,
  getSurveyFilter,
  getSurveyQues,
  getYearsApi,
  questionnaireNamesApi,
  clientNamesApi,
  searchQuestionnaire
} from 'utils/apis';
import { STATUS_CODE } from 'common/constants';
import { downloadExcel, processChartData, removeWhiteSpace } from 'utils/functions';
import { downloadPPTmulti } from './downloadPPT';

export const fetchYears = () => async (dispatch) => {
  try {
    dispatch(reportAction.getQuestionaireList());
    const response = await getYearsApi();
    // console.log('response.status', response.status);
    if (response.status === STATUS_CODE.Ok) {
      dispatch(reportAction.setYears(response.data.data));
    }
  } catch (err) {
    dispatch(reportAction.stopLoading());
    notification.error({
      message: 'Error',
      description:
        err.response?.status === 500
          ? 'Internal Server Error. Please try again later.'
          : 'Failed to fetch data. Please check your connection.',
      placement: 'topRight'
    });
  }
};

export const fetchquestionnaireNamesReports = (payload) => async (dispatch) => {
  try {
    dispatch(reportAction.getQuestionaireList());
    const response = await questionnaireNamesApi(payload);
    if (response.status === STATUS_CODE.Ok) {
      dispatch(reportAction.setQuestionnaireNames(response.data.data));
    }
  } catch (err) {
    dispatch(reportAction.stopLoading());
    notification.error({
      message: 'Error',
      description:
        err.response?.status === 500
          ? 'Internal Server Error. Please try again later.'
          : 'Failed to fetch data. Please check your connection.',
      placement: 'topRight'
    });
  }
};
export const fetchclientNamesReports = (payload) => async (dispatch) => {
  try {
    dispatch(reportAction.getClientList());
    const response = await clientNamesApi(payload);
    if (response.status === STATUS_CODE.Ok) {
      dispatch(reportAction.setClientNames(response.data.data));
    }
  } catch (err) {
    dispatch(reportAction.stopLoading());
    notification.error({
      message: 'Error',
      description:
        err.response?.status === 500
          ? 'Internal Server Error. Please try again later.'
          : 'Failed to fetch data. Please check your connection.',
      placement: 'topRight'
    });
  }
};
export const resetdata = () => async (dispatch) => {
  dispatch(reportAction.resetallData());
};
export const fetchSurveyQues = (payload) => async (dispatch) => {
  try {
    // dispatch(reportAction.getQuestionaireList());
    const response = await getSurveyQues(payload);
    if (response.status === STATUS_CODE.Ok) {
      await dispatch(reportAction.setSurveyQues(response.data.data));
    }
  } catch (err) {
    dispatch(reportAction.stopLoading());
    notification.error({
      message: 'Error',
      description:
        err.response?.status === 500
          ? 'Internal Server Error. Please try again later.'
          : 'Failed to fetch data. Please check your connection.',
      placement: 'topRight'
    });
  }
};
export const fetchSurveyQuesCrossTab = (payload) => async (dispatch) => {
  try {
    // dispatch(reportAction.getQuestionaireList());
    const response = await getCrossTabQuestions(payload);
    if (response.status === STATUS_CODE.Ok) {
      await dispatch(reportAction.setSurveyQuesCrosstab(response.data.data));
    }
  } catch (err) {
    console.log(err);
    // dispatch(reportAction.stopLoading());
    notification.error({
      message: 'Error',
      description:
        err.response?.status === 500
          ? 'Internal Server Error. Please try again later.'
          : 'Failed to fetch data. Please check your connection.',
      placement: 'topRight'
    });
  }
};
export const fetchSurveyFilters = (payload) => async (dispatch) => {
  try {
    dispatch(reportAction.getFilter());
    const response = await getSurveyFilter(payload);
    if (response.status === STATUS_CODE.Ok) {
      dispatch(reportAction.setFilterData(response.data.data));
    }
  } catch (err) {
    dispatch(reportAction.stopLoadingFilter());
    notification.error({
      message: 'Error',
      description:
        err.response?.status === 500
          ? 'Internal Server Error. Please try again later.'
          : 'Failed to fetch data. Please check your connection.',
      placement: 'topRight'
    });
  }
};
export const fetchSurveyChartData = (payload) => async (dispatch) => {
  try {
    dispatch(reportAction.getChartData());

    const response = await getSurveyChartData(payload);

    if (response.status === STATUS_CODE.Ok) {
      if (payload.cqId !== '') {
        const res = response.data.data;
        const chartdata = processChartData(res);
        dispatch(reportAction.setChartData(chartdata));
      } else {
        dispatch(reportAction.setChartData(response.data.data));
      }
    } else {
      console.log('err', response);
    }
  } catch (err) {
    notification.error({
      message: 'Error',
      description:
        err.response?.status === 500
          ? 'Internal Server Error. Please try again later.'
          : 'Failed to fetch data. Please check your connection.',
      placement: 'topRight'
    });
    dispatch(reportAction.stopChartLoader());
  }
};

export const fetchSearch = (payload) => async (dispatch) => {
  try {
    dispatch(reportAction.searchLoading(true));
    const response = await searchQuestionnaire(payload);
    if (response.status === STATUS_CODE.Ok) {
      dispatch(reportAction.setSearchData(response.data.data));
    }
  } catch (err) {
    dispatch(reportAction.searchLoading(false));
    notification.error({
      message: 'Error',
      description:
        err.response?.status === 500
          ? 'Internal Server Error. Please try again later.'
          : 'Failed to fetch data. Please check your connection.',
      placement: 'topRight'
    });
  }
};
export const fetchExcelData = (payload, type, qObj) => async (dispatch) => {
  const fileName = removeWhiteSpace(qObj.name);

  try {
    dispatch(reportAction.getQuestionaireList());
    const response = await getExcelDownloadData(payload);
    if (response.status === STATUS_CODE.Ok) {
      const chartdata = response.data.data.chartData;
      if (type == 'pptx') {
        downloadPPTmulti(chartdata, fileName);
      } else if (type == 'excel') {
        downloadExcel(chartdata, fileName);
        dispatch(reportAction.setExcelData(response.data.data));
      }
      dispatch(reportAction.stopLoading());
    }
  } catch (err) {
    dispatch(reportAction.stopLoading());
    notification.error({
      message: 'Error',
      description:
        err.response?.status === 500
          ? 'Internal Server Error. Please try again later.'
          : 'Failed to fetch data. Please check your connection.',
      placement: 'topRight'
    });
  }
};

function removeDuplicates(arr) {
  return [...new Set(arr)];
}

const mergeStackedData = (data) => {
  const mergedData = {};

  data.forEach((item) => {
    if (!mergedData[item.name]) {
      mergedData[item.name] = { name: item.name, data: [], count: [] };
    }
    mergedData[item.name].data.push(...item.data);
    mergedData[item.name].count.push(...item.count);
  });

  return Object.values(mergedData);
};

export const getChartOptions = (apiResponse) => {
  let stackArr = [];

  apiResponse.options.forEach((option) => {
    if (option.stack != '') {
      stackArr.push(option.stack);
    }
  });
  const uniqStack = removeDuplicates(stackArr);
  let categories = [];
  apiResponse.qText.map((item) => {
    uniqStack.map((stack) => {
      categories.push(`${item} (${stack})`);
    });
  });

  const seriesData = mergeStackedData(apiResponse.options);

  const options = {
    chart: {
      type: 'bar',
      marginRight: 100,
      height: 60 * seriesData[0].data.length
    },
    title: {
      text: ''
    },
    xAxis: {
      categories: categories
    },
    yAxis: {
      min: 0,
      title: {
        text: ''
      }
    },
    legend: {
      verticalAlign: 'top',
      useHTML: true,
      labelFormatter: function () {
        return '<span title="' + this.name + '">' + this.name + '</span>';
      }
    },
    tooltip: {
      backgroundColor: '#ffffff',
      borderColor: '#7438f2',
      borderRadius: 10,
      borderWidth: 2,
      style: {
        color: '#333',
        fontSize: '14px',
        width: 250
      },
      formatter: function () {
        let index = this.point.index;
        let count = this.series.options?.count[index];
        return `<b>${this.x}</b><br/><span style="color:${this.point.color}">●</span> ${
          this.series.name
        } <br/> =  <span style="font-weight: 500; font-familiy: 'Poppins'"><b>${this.y}% (N: ${
          count !== undefined ? count : 'N/A'
        })</b></span>`;
      },
      shadow: true,
      useHTML: false,
      shared: false,
      maxWidth: 250
    },
    plotOptions: {
      column: {
        stacking: 'normal',
        dataLabels: {
          enabled: true,
          style: {
            fontFamily: 'Poppins'
          },
          formatter: function () {
            let index = this.point.index;
            let count = this.series.options?.count[index];
            if (this.y != 0) {
              return `${this.y} %<span style="font-weight: normal; display:none;">, (N: ${
                count !== undefined ? count : 'N/A'
              })</span>`;
            } else {
              return null;
            }
          }
        }
      },
      bar: {
        stacking: 'normal',
        pointWidth: 30,
        dataLabels: {
          enabled: true,
          style: {
            fontFamily: 'Poppins'
          },
          formatter: function () {
            let index = this.point.index;
            let count = this.series.options?.count[index];
            if (this.y != 0) {
              return `${this.y} %<span style="font-weight: normal; display:none;">, (N: ${
                count !== undefined ? count : 'N/A'
              })</span>`;
            } else {
              return null;
            }
          }
        }
      }
    },
    series: seriesData
  };

  return options;
};
